import { testimonials } from "@/mocks/community";
import Avatar from "./Avatar";

const principles = [
  { icon: "ri-heart-3-line", title: "理性围观", text: "鼓励有理有据的观点，不欢迎无脑跟风与带节奏。" },
  { icon: "ri-voiceprint-line", title: "真实发言", text: "每条帖子与评论都来自真实瓜友，拒绝搬运与营销号灌水。" },
  { icon: "ri-eye-off-line", title: "保护隐私", text: "不传播未经核实的信息，不泄露任何人的个人隐私。" },
  { icon: "ri-team-line", title: "友好氛围", text: "对事不对人，给每个发言者基本尊重与善意。" },
];

export default function About() {
  return (
    <section id="about" className="w-full bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
          <div>
            <p className="inline-flex items-center gap-2 text-xs font-semibold tracking-wider text-primary-600 uppercase">
              <span className="w-6 h-px bg-primary-500" aria-hidden="true"></span> 关于我们
            </p>
            <h2 className="mt-2 text-2xl md:text-3xl font-black text-foreground-950">吃瓜17：把热闹聊出价值</h2>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              吃瓜17社区成立于 2021 年，最初只是一群朋友在深夜群里分享热门话题、交换看法的小角落。随着喜欢这种「认真围观、友善开麦」氛围的人越来越多，我们把它做成了一个开放论坛——娱乐、科技、生活、游戏、社会观察……凡是大家爱聊的，这里都有对应的板块。
            </p>
            <p className="mt-3 text-sm md:text-base text-foreground-700 leading-relaxed">
              我们相信，追热点不等于消耗时间。在吃瓜17，你可以快速看懂一个事件的来龙去脉，也能读到不同立场的理性声音；你可以安静围观，也可以随时下场分享自己的观点。这里的内容原则很简单：真实、理性、友善、有温度。
            </p>

            <h3 className="mt-7 text-base font-bold text-foreground-950">社区内容原则</h3>
            <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
              {principles.map((p) => (
                <div key={p.title} className="flex gap-3 items-start rounded-xl bg-background-50 border border-background-200 p-4">
                  <span className="w-9 h-9 rounded-lg bg-accent-100 text-accent-700 flex items-center justify-center shrink-0">
                    <i className={p.icon} aria-hidden="true"></i>
                  </span>
                  <div>
                    <h4 className="text-sm font-bold text-foreground-900">{p.title}</h4>
                    <p className="mt-1 text-xs text-foreground-600 leading-relaxed">{p.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-base font-bold text-foreground-950">来自瓜友的口碑</h3>
            <div className="mt-4 space-y-4">
              {testimonials.map((t) => (
                <figure key={t.name} className="rounded-2xl bg-background-50 border border-background-200 p-5">
                  <div className="flex items-center gap-1 text-primary-500">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm" aria-hidden="true"></i>
                    ))}
                  </div>
                  <blockquote className="mt-3 text-sm text-foreground-700 leading-relaxed">
                    「{t.text}」
                  </blockquote>
                  <figcaption className="mt-4 flex items-center gap-3">
                    <Avatar char={t.char} tone={t.tone} size="w-10 h-10 text-base" />
                    <div>
                      <p className="text-sm font-bold text-foreground-900">{t.name}</p>
                      <p className="text-xs text-foreground-400">{t.role}</p>
                    </div>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}